// src/components/saved-cars/capture.ts

import { toastSuccess } from "../toast/toast";

/**
 * Capture the garage grid as an image using native Canvas
 * Images are already data URLs in localStorage, so no network requests needed
 */
export function captureGaragePhoto(): void {
  const garageContainer = document.getElementById("garage-cars-list");
  if (!garageContainer) return;

  const images = garageContainer.querySelectorAll<HTMLImageElement>("li > img");
  if (images.length === 0) {
    toastSuccess("No cars to capture");
    return;
  }

  // Grid settings (5:4 aspect ratio to match CSS)
  const cols = images.length >= 8 ? 3 : 2;
  const rows = Math.ceil(images.length / cols);
  const cellWidth = 400;
  const cellHeight = 320;

  const canvasWidth = cols * cellWidth;
  const canvasHeight = rows * cellHeight;

  const canvas = document.createElement("canvas");
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  // Background
  ctx.fillStyle = "#1a1a1a";
  ctx.fillRect(0, 0, canvasWidth, canvasHeight);

  // Draw each image - they're already loaded as data URLs
  for (let i = 0; i < images.length; i++) {
    const img = images[i];
    const col = i % cols;
    const row = Math.floor(i / cols);
    const x = col * cellWidth;
    const y = row * cellHeight;

    // Draw image to fit cell while maintaining aspect ratio (contain)
    const scale = Math.min(cellWidth / img.naturalWidth, cellHeight / img.naturalHeight);
    const drawWidth = img.naturalWidth * scale;
    const drawHeight = img.naturalHeight * scale;
    const offsetX = (cellWidth - drawWidth) / 2;
    const offsetY = (cellHeight - drawHeight) / 2;

    ctx.save();
    ctx.beginPath();
    ctx.rect(x, y, cellWidth, cellHeight);
    ctx.clip();
    ctx.drawImage(img, x + offsetX, y + offsetY, drawWidth, drawHeight);
    ctx.restore();
  }

  // Add watermark
  ctx.font = "14px Arial, sans-serif";
  ctx.fillStyle = "rgba(255, 255, 255, 0.6)";
  ctx.textAlign = "right";
  ctx.textBaseline = "bottom";
  ctx.fillText("Made with GarageWish.com", canvasWidth - 10, canvasHeight - 10);

  // Download the image
  const link = document.createElement("a");
  link.download = "my-garage.png";
  link.href = canvas.toDataURL("image/png");
  link.click();
  toastSuccess("Garage photo saved!");
}
